import React from 'react'
import { useParams } from 'react-router-dom'
import ServiceMainScreen from '../../components/ServiceMainScreen/ServiceMainScreen'
import ServiceCardsCarousel from '../../components/ServiceCardsCarousel/ServiceCardsCarousel'
import InfoBlock from '../../components/InfoBlock/InfoBlock'
import TableBlock from '../../components/TableBlock/TableBlock'
import TextBlocksBlock from '../../components/TextBlocksBlock/TextBlocksBlock'
import StageBlock from '../../components/StageBlock/StageBlock'
import WorkServiceBlock from '../../components/WorkServiceBlock/WorkServiceBlock'
import QuestionBlock from '../../components/QuestionBlock/QuestionBlock'
import SecondCommunicationBlock from '../../components/SecondCommunicationBlock/SecondCommunicationBlock'
import { useServiceData } from '../../hooks/useServiceData'

const Service = () => {
  const { slug } = useParams()
  const { data: service, isLoading } = useServiceData(slug)
  const faq = service?.faq
    ? [...service.faq].sort((a, b) => a.order - b.order)
    : []

  return (
    <>
      <ServiceMainScreen />
      <InfoBlock />
      <ServiceCardsCarousel />
      <TableBlock />
      <TextBlocksBlock />
      <StageBlock />
      <WorkServiceBlock />
      <QuestionBlock items={faq} isLoading={isLoading} ariaLabel="Часто задаваемые вопросы по услуге" />
      <SecondCommunicationBlock />
    </>
  )
}

export default Service
